// Project and Task Status Constants
export const STATUS_LABELS = {
  PENDING: "Pending",
  ACTIVE: "Active",
  DONE: "Completed",
};

export const STATUS_OPTIONS = [
  { id: "PENDING", name: STATUS_LABELS.PENDING },
  { id: "ACTIVE", name: STATUS_LABELS.ACTIVE },
  { id: "DONE", name: STATUS_LABELS.DONE },
];

// Helper function to get status label
export const getStatusLabel = (status) => {
  return STATUS_LABELS[status] || "—";
};
